const HEADER_SELECTOR = '.app-header';
const MAX_HEADER_OFFSET_PX = 200;

function isVisibleFixedChrome(el) {
  if (!el) {
    return false;
  }

  const style = window.getComputedStyle(el);
  return style.display !== 'none'
    && style.visibility !== 'hidden'
    && style.position === 'fixed';
}

export function measureHeaderOffset(root = document) {
  const el = root.querySelector(HEADER_SELECTOR);
  if (!isVisibleFixedChrome(el)) {
    return 0;
  }

  const rect = el.getBoundingClientRect();
  if (rect.height <= 0) {
    return 0;
  }

  return Math.min(Math.ceil(rect.bottom), MAX_HEADER_OFFSET_PX);
}

export function syncHeaderOffset(headerEl) {
  const height = measureHeaderOffset(document);
  const spacerHeight = height > 0 ? height : null;

  if (spacerHeight) {
    document.documentElement.style.setProperty('--header-spacer-height', `${spacerHeight}px`);
    document.documentElement.style.setProperty('--app-header-offset', `${spacerHeight}px`);
  }

  return spacerHeight || 0;
}

let resizeObserver = null;
let observedHeader = null;

export function bindHeaderOffsetSync(headerEl) {
  if (!headerEl) {
    return () => {};
  }

  const runSync = () => {
    window.requestAnimationFrame(() => {
      syncHeaderOffset(headerEl);
    });
  };

  runSync();

  if (typeof ResizeObserver !== 'undefined') {
    resizeObserver = new ResizeObserver(runSync);
    resizeObserver.observe(headerEl);
    observedHeader = headerEl;
  }

  window.addEventListener('orientationchange', runSync);
  window.addEventListener('resize', runSync);
  window.visualViewport?.addEventListener('resize', runSync);

  return () => {
    resizeObserver?.disconnect();
    resizeObserver = null;
    observedHeader = null;
    window.removeEventListener('orientationchange', runSync);
    window.removeEventListener('resize', runSync);
    window.visualViewport?.removeEventListener('resize', runSync);
  };
}

export function refreshHeaderOffset() {
  return syncHeaderOffset(observedHeader);
}
